import { IdentificationIcon, PlusIcon } from '@heroicons/react/24/solid';
import { Button } from '@heroui/react';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePageLoading } from '@/app/components/page-loading.tsx';
import StaffSearchForm from '@/app/components/staff/staff-search-form.tsx';
import { useSecurityContext } from '@/app/hooks/security-provider.tsx';
import { StaffRoleEnum } from '@/app/types/staff-member.type.ts';
import { UserTypeEnum } from '@/app/types/user-type.ts';
import { Heading } from '@/primitives/heading.tsx';
import SecurityCheck from '@/primitives/security.check.tsx';
import { useFetchStaffMembersQuery } from '@/slices/staff-api-slice.ts';
import RepStaffMemberTable from './rep-staff-member-table.tsx';
import StaffMemberTable from './staff-member-table.tsx';

const StaffListWrapper = () => {
  const [searchParams] = useSearchParams();
  const { currentAccount } = useSecurityContext();
  const searchAccountKey = searchParams.get('accountKey');
  const currentAccountKey = currentAccount?.key ?? null;
  const accountFilterReady = searchAccountKey === currentAccountKey;
  const { data, isLoading } = useFetchStaffMembersQuery(searchParams.toString(), {
    skip: !accountFilterReady,
  });
  const navigate = useNavigate();
  const { showPageLoading, hidePageLoading } = usePageLoading();

  useEffect(() => {
    if (isLoading) {
      showPageLoading('staff-list');
    } else {
      hidePageLoading('staff-list');
    }

    return () => hidePageLoading('staff-list');
  }, [isLoading]);

  return (
    <div className='flex flex-col gap-5'>
      <Heading icon={<IdentificationIcon className='size-7' />}>Staff Members</Heading>
      <div className='flex justify-between'>
        <StaffSearchForm />
        <div>
          <SecurityCheck
            allowedUserTypes={[UserTypeEnum.Admin, UserTypeEnum.StaffMember]}
            minimumStaffRole={StaffRoleEnum.SiteAdministrator}
          >
            <Button
              color='primary'
              variant='solid'
              onPress={() => navigate('/staff/new')}
              startContent={<PlusIcon className='size-4' />}
            >
              Add Staff
            </Button>
          </SecurityCheck>
        </div>
      </div>
      <div>
        <SecurityCheck
          allowedUserTypes={[UserTypeEnum.Admin, UserTypeEnum.StaffMember]}
          minimumStaffRole={StaffRoleEnum.SiteAdministrator}
        >
          <StaffMemberTable data={data} />
        </SecurityCheck>
        <SecurityCheck allowedUserTypes={[UserTypeEnum.DrugRep]}>
          <RepStaffMemberTable data={data} />
        </SecurityCheck>
      </div>
    </div>
  );
};

export default StaffListWrapper;
